<template>
  <div class="container" v-loading="loading" element-loading-text="页面中转，请稍后" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>

<script>
import axios from "axios";
import urlSet from "@/api/baseurl.js";
export default {
  data() {
    return {
      loading: true,
      ticket: "",
      redirect: "",
    };
  },
  created() {
    if (window.location.search) {
      let search = window.location.search; //获取查询参数
      window.location.replace("/login" + search);
    }
    this.ticket = this.$route.query.ticket;
    this.code = this.$route.query.code;
  },
  mounted() {
    this.cpuLogin();
  },
  methods: {
    cpuLogin() {
      this.loading = true;
      if (this.ticket) {
        this.$http({
          url: `${urlSet.baseUrl}api/v1/cas/login?ticket=${this.ticket}&code=${localStorage.getItem("schoolCode")}`,
          method: "GET",
        }).then(res => {
          localStorage.setItem("jyx_token", res.data);
          this.$message.success("登录成功");
          setTimeout(() => {
            this.loading = false;
            this.getMineInfo();
            this.getInfo();
            // let url = `${window.location.origin}/${this.redirect}`;
          }, 800);
        });
      } else {
        this.$http({
          url: `${urlSet.baseUrl}api/v1/sso/login?code=${this.code}`,
          method: "GET",
        }).then(res => {
          localStorage.setItem("jyx_token", res.data);
          this.$message.success("登录成功");
          setTimeout(() => {
            this.loading = false;
            this.getMineInfo();
            this.getInfo();
          }, 800);
        });
      }
    },
    getMineInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.$store.commit("getUserName", res.data.userName);
        localStorage.setItem("userName", res.data.userName);
        location.href = `/articleSearch`;
      });
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/getInfo",
        method: "GET",
      }).then(res => {
        let str = res.data.roles.toString();
        localStorage.setItem("roles", str);
      });
    },
  },
};
</script>

<style scoped>
.container {
  min-width: calc(100vw);
  min-height: calc(100vh);
}
</style>
